import store from '@/store'
import {router} from '@/router'

export function gohualist() {
	console.log(store.state)
	switch(store.state.hua.type){
		case 1:
			router.replace('/index/yhlist');break;
		case 2:
			router.replace('/index/ghlist');break;
		case 3:
			router.replace('/index/sflist');break;
	}
}